import KNB from '@wmfe/mach-pro-knb'

interface IGoToLoginOpation {
  onSuccess?: () => void
  onFail?: () => void
}

export const checkNeedLogin = (options?: IGoToLoginOpation) => {
  const { onSuccess, onFail } = options || {}
  const Login = Mach.requireModule('Login')
  const isLogin = Login?.isLogin?.()
  if (isLogin) {
    return false
  }

  KNB &&
    KNB?.login({
      success: onSuccess,
      fail: onFail,
    })
  return true
}

export const getUserId = () => {
  const login = Mach.requireModule('Login')
  return login?.getUserInfo?.()?.userId
}
